/* eslint-disable react/prop-types */
import React from 'react';
import PostPreviewWrapper from './PostPreview/PostPreviewWrapper';
import PostPreviewHeader from './PostPreview/PostPreviewHeader';
import PostPreviewImage from './PostPreview/PostPreviewImage';
import PostPreviewFooter from './PostPreview/PostPreviewFooter';
import useMediaQuery from '../../hooks/useMediaQuery';

// Main PostPreview Component
const PostPreview = ({ platform, post, layout = 'feed', businessName, logo, loading = false }) => {
  const { isMobile, isSmallMobile } = useMediaQuery();
  const { caption, path, imageUrl } = post || {};
  const isMobileView = isSmallMobile || isMobile;
  const imageSrc = imageUrl || path;
  const defaultImage =
    layout === 'story'
      ? 'https://placehold.co/720x1280/475569/475569/png?text='
      : 'https://placehold.co/800x800/475569/475569/png?text=';
  const footerElement = (
    <PostPreviewFooter
      layout={layout}
      platform={platform}
      caption={loading ? 'Loading...' : caption}
      businessName={businessName}
      isMobile={isMobileView}
    />
  );

  return (
    <PostPreviewWrapper
      layout={layout}
      footer={layout === 'story' ? footerElement : null}
      loading={loading}
    >
      <PostPreviewHeader
        layout={layout}
        platform={platform}
        logo={logo}
        businessName={businessName}
        isMobile={isMobileView}
      />

      <PostPreviewImage imageUrl={loading ? defaultImage : imageSrc} layout={layout} />

      {layout !== 'story' && footerElement}
    </PostPreviewWrapper>
  );
};

export default PostPreview;
